import Image from 'next/image';
import { useState } from 'react';

interface NewsCardProps {
  title: string;
  description: string;
  thumbnail?: string;
  onClick?: () => void;
}

export const NewsCard = ({ title, description, thumbnail, onClick }: NewsCardProps) => {
  const [isError, setIsError] = useState(false);

  return (
    <article
      onClick={onClick}
      className='flex h-full cursor-pointer flex-col gap-4 transition-transform duration-300 hover:-translate-y-2'>
      <div className='relative w-full overflow-hidden rounded' style={{ aspectRatio: '356/178' }}>
        {thumbnail && !isError ? (
          <img
            onError={() => setIsError(true)}
            src={thumbnail}
            alt={title}
            className='absolute inset-0 h-full w-full object-cover'
          />
        ) : (
          <div className='absolute inset-0 bg-[#1a1a1a] flex items-center justify-center'>
            <Image src={'/logo.png'} alt={title} width={100} height={100} />
          </div>
        )}
      </div>

      <div className='flex flex-col gap-4 pb-6'>
        <h3
          className='text-base font-semibold leading-[22px] text-white md:text-xl'
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>
          {title}
        </h3>

        <p
          style={{
            fontFamily: 'sans-serif',
          }}
          className='text-sm line-clamp-3 leading-5 text-white/65 md:text-base md:leading-5'>
          {description}
        </p>

        <span className='text-sm leading-5 text-white underline md:text-base'>Read more</span>
      </div>
    </article>
  );
};
